import { Editor } from '@tinymce/tinymce-react';
import { resolvePath } from '@webapps/utils';
import PropTypes from 'prop-types';

const FormikTinyMCE = ({
  formik: { errors, handleChange, onBlur, setFieldValue, touched, values },
  name,
  onChange,
  ...props
}) => (
  <Editor
    apiKey="b1pqu690rf9asjo2e32wbtvxi2grorij77nx6a7mcbm0t0j4"
    error={!!resolvePath(touched, name, '') && !!resolvePath(errors, name, '')}
    helperText={resolvePath(touched, name, '') && resolvePath(errors, name, '')}
    id={name}
    init={{
      height: 500,
      menubar: true,
      plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table paste code help wordcount',
      ],
      toolbar:
        'undo redo | formatselect | ' +
        'bold italic backcolor | alignleft aligncenter ' +
        'alignright alignjustify | bullist numlist outdent indent | ' +
        'removeformat | help',
    }}
    name={name}
    onBlur={onBlur}
    onChange={onChange || handleChange}
    onEditorChange={(content) => {
      setFieldValue(name, content);
    }}
    textareaName={name}
    value={resolvePath(values, name, '')}
    {...props}
  />
);

FormikTinyMCE.propTypes = {
  field: PropTypes.elementType,
  name: PropTypes.string,
  formik: PropTypes.object,
  children: PropTypes.node,
  onChange: PropTypes.func,
};

export default FormikTinyMCE;
